<style scoped>
.section {
  padding: 24px;
}

.section.bordered {
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
}

.wrapper-outer {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
}

.wrapper-inner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}

.wrapper-inner img {
  height: 100%;
  display: inline-block;
}

.variants {
  overflow-x: auto;
  white-space: nowrap;
}

.variants .variant {
  background-color: #f9f9f9;
  cursor: pointer;
  position: relative;
  padding: 24px 12px;
  border: 1px solid transparent;
  border-bottom: 2px solid transparent;
  overflow: hidden;
}

.variant:not(.disabled) .selection-indicator {
  position: absolute;
  /* right: 10px; */
  top: 10px;
}

.variant.disabled .selection-indicator {
  display: none;
}

.variant.selected:not(.disabled) {
  background-color: white;
  border: 1px solid #f1f1f1;
  border-bottom: 2px solid #4baf4f;
}

.variant.disabled::after {
  /* content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #9292920d; */

  content: 'Out of Stock';
  position: absolute;
  /* left: 0; */
  /* top: 0; */
  /* bottom: 0; */
  /* transform: translate(-50%, -50%); */
  /* right: 0; */
  /* top: 50%; */
  /* left: 50%; */
  /* align-items: center; */
  letter-spacing: 0;
  /* justify-content: center; */
  color: #c30a0a;
  background-color: #fbe6e6;
  padding: 5px;
  letter-spacing: 0;
  font-size: 0.8em;
  border: 1px solid #f9dcdc;

  transform: rotateZ(45deg);
  position: absolute;
  top: 37px;
  width: 150%;
  left: -15px;
  text-align: center;
  font-weight: bold;
}

.variant.disabled {
  border-color: #bdbdbd0a;
  pointer-events: none;
  background-color: #bbbbbb1c;
}

.variant.disabled * {
  color: gray !important;
}

#drink-image {
  position: absolute;
  /* top: 50%; */
  top: 0;
  bottom: 0;
}

#drink-image .wrapper-outer {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.invisible {
  visibility: hidden;
}

p.variantcode {
  word-wrap: normal;
  white-space: normal;
}
.flag {
  text-decoration: line-through;
  color: gray !important;
}
.disPrice {
  font-weight: 900;
  font-size: 1.4rem;
}
.dislabel {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 1.4rem;
}
.ribbon {
  position: absolute;
  right: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 100px;
  height: 100px;
  text-align: right;
}
.ribbon span {
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  line-height: 26px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 100px;
  display: block;
  background: #79a70a;
  background: linear-gradient(#f70505 0%, #8f0808 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 19px;
  right: -21px;
}
/* .ribbon span::before {
  content: "";
  position: absolute; left: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid #8F0808;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #8F0808;
}
.ribbon span::after {
  content: "";
  position: absolute; right: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #8F0808;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #8F0808;
} */
.variant {
  position: relative;
}
</style>
<template lang='pug'>
.row.no-margin(v-if='product')
  #drink-image.col.m4.l6.no-padding.hide-on-small-only
    .wrapper-outer
      .wrapper-inner
        img(:src='selectedVariant.photo')
  .col.s12.hide-on-med-and-up
    .vspace.large
    .wrapper-outer
      .wrapper-inner
        img(:src='selectedVariant.photo')
  .col.s12.m8.l6.offset-m4.offset-l6.no-padding.light-gray
    .section.light-gray
      //- pre {{user}} thjdhgk
      p.title.large.no-margin {{ product.name }}
      //- p.subtitle.small sold by
      //-   router-link(:to='{name: "store", params: {shopCode: product.shop.code}}' target='_blank') {{product.shop.name}}
    .section.bordered.light-gray
      .row
        .col.s12.m6
          p.caption Bottler
          p.button.no-margin-top {{ product.bottler }}

        .col.s12.m6
          p.subtitle Country
          p.title.no-margin-top {{ product.country }}

        .col.s12.m6
          p.subtitle Region
          p.title.no-margin-top {{ product.region }}

        .col.s12.m6
          p.subtitle Essence
          p.title.no-margin-top {{ product.essence }}

    .section.light-gray
      .row
        .col.s12
          p.subtitle.light Choose an item
      .row.variants
        .variant.col.s12.m4(
          v-for='variant in product.variants',
          @click='selectVariant(variant)',
          :class='{ disabled: !variant.availableStock, selected: variant.variantCode === selectedVariant.variantCode }',
          :id='variant.variantCode'
        )
          i.material-icons.selection-indicator.green-text(
            v-if='variant.variantCode == selectedVariant.variantCode'
          ) check_circle

          div(v-if='variant.discounted.length')
            p.variantcode {{ variant.variantCode }}
            p.subtitle Volume
            p.title.no-margin-top {{ variant.volumeCl ? variant.volumeCl + "cl" : "Unavailable" }}
            p.subtitle Alcohol Content
            p.title.no-margin-top {{ variant.alcoholContent ? variant.alcoholContent + "%" : "Unavailable" }}
            p.subtitle Age
            p.title.no-margin-top {{ variant.age ? variant.age + " years" : "Unavailable" }}
            p.title.green-text(
              v-for='vdiscount in variant.discounted',
              v-bind:class='vdiscount.amount.length > 0 ? onSaleClass : ""'
            ) {{ $utils.formatter.formatAmount(variant.price) }}
            div(
              v-for='vdiscount in variant.discounted',
              v-if='variant.discounted.length'
            )
              p.title.red-text.disPrice(
                v-if='vdiscount.amount.length && vdiscount.discountType === "percent"'
              ) {{ $utils.formatter.formatAmount(variant.price - (vdiscount.amount / 100) * variant.price) }}
              p.title.red-text.disPrice(
                v-if='vdiscount.amount.length && vdiscount.discountType === "fix"'
              ) {{ $utils.formatter.formatAmount((vdiscount.amount / 100) * variant.price - variant.price) }}
            .ribbon(v-for='vdiscount in variant.discounted')
              span(
                v-if='vdiscount.amount.length && vdiscount.discountType === "percent"'
              ) {{ vdiscount.amount }} % off
              span(v-else) PHP {{ vdiscount.amount }} off
          div(v-else)
            p.variantcode {{ variant.variantCode }}
            p.subtitle Volume
            p.title.no-margin-top {{ variant.volumeCl ? variant.volumeCl + "cl" : "Unavailable" }}
            p.subtitle Alcohol Content
            p.title.no-margin-top {{ variant.alcoholContent ? variant.alcoholContent + "%" : "Unavailable" }}
            p.subtitle Age
            p.title.no-margin-top {{ variant.age ? variant.age + " years" : "Unavailable" }}
            p.title.green-text(
              v-bind:class='isDiscounted === false ? onSaleClass : ""'
            ) {{ $utils.formatter.formatAmount(variant.price) }}
    .section.light-gray
      .row
        .col.s12
          p.subtitle.light Choose delivery schedule
      .row
        .col.s12.m6.l4(v-for='schedule in availableSchedules')
          span
            label
              input.with-gap(
                type='radio',
                v-model='selectedSchedule',
                :value='schedule.type',
                @change='onDeliveryChange'
              )
              span(v-if='schedule.type === "same_day"') For Today
              span(v-else-if='schedule.type === "range"') {{  schedule.value.split(';')[0] + " - " + schedule.value.split(';')[1] + " business days"  }}
              span(v-else-if='schedule.type === "scheduled"') {{ "Scheduled" }}
            //- pre {{selectedVariant}}
            //- pre {{deliverySchedule}}
            //- pre {{product}}
      div(v-if='deliveryDate')
        .row
          .col.s12
            p.subtitle.light Deliver On
        .row
          .col.s12
            a.btn.transparent.waves-effect.black-text(@click='chooseDate') {{ deliveryDate }}
      input.datepicker(type='hidden', ref='deliveryDatePicker')
    .section.light-gray
      //- app-add-cart-btn(v-bind='{product: product, variant: selectedVariant, deliverySchedule: deliverySchedule}', @added='onAdded')
      AppAddCartBtn(
        :product='product',
        :variant='selectedVariant',
        :deliverySchedule='deliverySchedule'
      )
      //- .row
      //-     .col.s12.m6
      //-       .btn-compound.bordered.width100
      //-         a.btn-compound-item.waves-effect
      //-           i.material-icons remove
      //-         span.btn-compound-item.grow.center-align 454
      //-         a.btn-compound-item.waves-effect
      //-           i.material-icons add
      //-     .col.s12.m6
      //-       a.btn.width100.waves-effect
      //-         | Add to Cart

      //-     p.red-text.col.s12(v-if='!availableInLocation') This product is not available in your chosen location
</template>
<script>
/* eslint-disable no-undef */
import AppProductCard from '@/components/app-product-card'
import AppAddCartBtn from '@/components/app-add-cart-btn'
import axios from 'axios'
import dateformat from 'dateformat'
import Store from '../store/index'
// let userere = Store.getters.customer
// do stuff with user

export default {
  name: 'appdrinkdetails',
  props: ['viewProduct', 'onAddedHandler'],
  data () {
    return {
      product: null,
      selectedVariant: null,
      schedules: [],
      selectedSchedule: null,
      deliverySchedule: null,
      deliveryDate: null,
      isDiscounted: true,
      onSaleClass: 'flag',
      Store
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    availableSchedules () {
      if (!this.schedules.length) {
        return []
      }

      return this.schedules
        .map((schedule) => {
          return {
            type: schedule.propertyType.split(':')[2],
            value: schedule.propertyValue
          }
        })
        .sort((a, b) => {
          if (a.type === 'scheduled') {
            return 1
          }
          return 0
        })
    }
  },
  created () {
    document.head.querySelector('meta[name=description]').content = 'View Product Details'
    this.getProduct(this.viewProduct.shopCode, this.viewProduct.productCode)
  },
  watch: {
    viewProduct () {
      if (!this.viewProduct) {
        return
      }

      this.getProduct(this.viewProduct.shopCode, this.viewProduct.productCode)
    },
    'product.variants' () {
      this.updateVariantSelection()
    },
    '$route.query.v' () {
      this.updateVariantSelection()
    }
  },
  methods: {
    onDeliveryChange () {
      this.deliverySchedule = this.selectedSchedule
      this.deliveryDate = null
      if (this.selectedSchedule === 'scheduled') {
        this.$M.Datepicker.init(this.$refs.deliveryDatePicker, {
          minDate: new Date(),
          onSelect: this.onDateSelected,
          onClose: this.onDateClose,
          showClearBtn: false
        })
        this.$M.Datepicker.getInstance(this.$refs.deliveryDatePicker).open()
      } else if (this.selectedSchedule === 'range') {
        this.availableSchedules.forEach((schedule) => {
          if (schedule.type === 'range') {
            this.deliverySchedule = this.selectedSchedule + ':' + schedule.value
          }
        })
      }
    },
    onDateSelected (date) {
      this.$M.Datepicker.getInstance(this.$refs.deliveryDatePicker).close()
    },
    onDateClose (e) {
      const date = this.$M.Datepicker.getInstance(this.$refs.deliveryDatePicker)
        .date

      if (this.selectedSchedule === 'scheduled' && !date) {
        this.selectedSchedule = null
        this.deliverySchedule = null
        this.deliveryDate = null
      } else {
        this.deliverySchedule = this.selectedSchedule + ':' + dateformat(date, 'yyyy-mm-dd')
        this.deliveryDate = dateformat(date, 'ddd, mmm dd')
      }
    },
    chooseDate () {
      this.$M.Datepicker.getInstance(this.$refs.deliveryDatePicker).open()
    },
    getProduct (shopCode, productCode) {
      axios
        .get(
          `${this.$config.API_URL}/products/${shopCode}/${encodeURI(
            productCode
          )}`
        )
        .then((res) => {
          this.product = res.data
          this.selectedVariant = res.data.variants[0]
          document.title = this.product.name + ' - Inom PH'
        })
        .then(() => {
          return this.getDeliverySchedules()
        })
        .catch((err) => {
          this.$snackbar.show({
            text: 'Oops, there seems to be a problem: ' + err.message
          })
        })
    },
    getDeliverySchedules () {
      return this.$http
        .get(
          `${this.$config.API_URL}/suppliers/${this.product.supplier.id}/settings`
        )
        .then((settings) => {
          settings.data.forEach((setting) => {
            if (setting.propertyType.startsWith('delivery:schedule')) {
              this.schedules.push(setting)
            }
          })
        })
    },
    selectVariant (variant) {
      this.selectedVariant = variant
    },
    onAdded () {
      if (this.onAddedHandler) {
        this.onAddedHandler(this.selectedVariant)
      }
    },
    updateVariantSelection () {
      if (!this.$route.query.v || !this.product.variants) {
        return
      }

      this.product.variants.some((variant) => {
        const match = variant.variantCode === this.$route.query.v
        if (match) {
          this.selectedVariant = variant
        }
        return match
      })
    }
  },
  components: {
    AppProductCard,
    AppAddCartBtn
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-drink-details.vue